import { API_ENDPOINTS, LOYALTY_API_HOST } from "../constants";
import { customApiCall } from "../utils/fetcher";

export const getLoyaltyScanData = async (campaignId: string) => {
    const method = "GET";
    const searchParams = {
        campaignId,
    };

    const response = await customApiCall(LOYALTY_API_HOST, API_ENDPOINTS.LOYALTY_EVALUATION, {
        method,
        searchParams,
    });
    return response;
};

export const availDineCash = async (campaignId: string) => {
    const method = "POST";
    const searchParams = {
        campaignId,
    };

    const response = await customApiCall(LOYALTY_API_HOST, API_ENDPOINTS.AVAIL_DINE_CASH, {
        method,
        searchParams,
    });
    return response;
};
